<template>
  <circular-icon-button
    class="bookmark-button"
    :icon-name="hasBookmark ? 'bookmark-icon-filled' : 'bookmark-icon'"
    :icon-size="16"
    @click="toggleBookmark"
  />
</template>

<script>
import CircularIconButton from '@/components/ui/CircularIconButton';
import BookmarksMixin from '@/mixins/bookmarks';

export default {
  components: {
    CircularIconButton,
  },
  mixins: [BookmarksMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    flashcardId() {
      return this.flashcard?.id;
    },
    categoryId() {
      return this.category?.id;
    },
  },
};
</script>
